import {DefaultUrl} from "../../api/easyData";

/**
 * EastDataList组件属性
 */
export default {
    /**
     * 是否显示分页
     */
    showPagination: {type: Boolean, default: true},
    showTableForm: {type: Boolean, default: true},
    /**
     * @private
     * Form表单props数据(属性参考[EasyDataForm](web-comp/EasyDataForm.md?id=formactionprops)组件
     */
    formProps: {type: Object, default: () => {return {}}},
    /**Table 表格props((属性参考[EasyDataForm](web-comp/EdTable.md)组件)
     * - 示例 1
     * :tableProps="{operateFixed: 'right'}" 配置table操作拦固定在右侧
     */
    tableProps: {type: Object},
    // action 操作区域按钮属性(属性参考[EasyDataForm](web-comp/EasyDataForm.md?id=formactionprops)组件
    actionProps: {type: [Object, Boolean], default: () => {}},
    /**
     * 数据查询条件组装对象,持对象和数据
     * - 示例 1
     * `queryParams:{id:'123'}`
     * - 示例 2
     * `queryParams:[{fieldName: 'id',fieldValue: '123',operator: 'like'}]`
     * 示例 2 写法更强大,可以自定义逻辑.
     * 示例 1 中的key必须时数据源中存在的字段,示例 2 可以是不存在的字段,sqlId可能用到, 这里需要开发者自己保证字段的正确性
     */
    queryParams: {type: [Array, Object],},
    /**
     * 新增数据时默认传递数据
     * - 示例 1
     * formData: {ms:'测试'}
     * - 示例2
     * formData: {key: {ms:'测试'}}
     * @default {}
     */
    formData: {
        type: [Array, Object], default: () => {
        }
    },

    /**
     * sqlId
     * - 示例
     * `SELECT a.* from demo a WHERE a.id ='${id}'`
     * @default null
     */

    sqlId: {type: String, default: null},

    /**
     * 动态表单id
     * @default ''
     */
    easyFormId: {type: String, default: ''},

    /**
     * 列表数据类型,expand则为可以展开表格
     * @default ''
     */
    columnType: {type: String, default: ''},
    /**
     * 列表自定义传入列数据,前提是keyInfo里面存在的key
     * - 示例
     *  `diyColums: [{ label: 'id',prop: 'id',}, {label: '名称',prop: 'name', }]`
     *  @default []
     */
    diyColums: {type: Array, default: () => []},

    /**
     * 是否自动查询
     * @default true
     */
    autoQuery: {type: Boolean, default: true},
    /**
     * 排序规则
     * - 示例
     * `[{fieldName: 'create_time,id', order: 'DESC'},{fieldName: 'template_name', order: 'ASC' }]`
     * @default [{ fieldName: 'create_time', order: 'DESC' }]
     */
    orderBy: {
        type: Array, default: () => {
            return [{
                fieldName: 'create_time', order: 'DESC'
            }]
        }
    },
    /**
     * sqlId情况下是否把查询条件拼接到sqlId中,默认开启
     * @default true
     */
    sqlIdAddWhere: {
        type: Boolean, default: true
    },
    /**
     * 覆盖默认请求后端接口地址
     * @default {insertUrl: '/api/easyData/insertData',updateUrl: '/api/easyData/updateData',pageUrl: '/api/easyData/page',deleteUrl: '/api/easyData/deleteData',exportDataList: '/api/easyData/exportDataList'}
     */
    httpUrl: {
        type: Object, default: () => {
            return {
                // 表单保存地址
                insertUrl: DefaultUrl.insertData, // 表单更新地址
                updateUrl: DefaultUrl.updateData, // table 数据请求地址
                pageUrl: DefaultUrl.page, //分页查询地址
                deleteUrl: DefaultUrl.deleteData,
                exportDataList: DefaultUrl.exportDataList
            }
        }
    },
}
